// extracted by mini-css-extract-plugin
export var arrow = "Breadcrumbs-module--arrow--136c4";
export var arrowNo = "Breadcrumbs-module--arrow_no--7b3d2";
export var arrowYes = "Breadcrumbs-module--arrow_yes--0d1de";
export var breadcrumbItem = "Breadcrumbs-module--breadcrumbItem--87631";
export var breadcrumbItemLabel = "Breadcrumbs-module--breadcrumbItemLabel--44199";
export var breadcrumbLink = "Breadcrumbs-module--breadcrumbLink--225bb";
export var breadcrumbSepatator = "Breadcrumbs-module--breadcrumbSepatator--94c57";
export var breadcrumbsWrapper = "Breadcrumbs-module--breadcrumbsWrapper--c99bc";
export var flex = "Breadcrumbs-module--flex--3aeb7";
export var flex1 = "Breadcrumbs-module--flex_1--1f36f";
export var flexCenter = "Breadcrumbs-module--flex_center--189bc";
export var flexCenterCol = "Breadcrumbs-module--flex_center_col--77d3b";
export var flexCol = "Breadcrumbs-module--flex_col--0efb8";
export var flexFixCenterCol = "Breadcrumbs-module--flex_fix_center_col--dedd5";
export var flexFixedCenterCol = "Breadcrumbs-module--flex_fixed_center_col--31a94";
export var lastItem = "Breadcrumbs-module--lastItem--f9459";
export var rotating = "Breadcrumbs-module--rotating--6a28c";